import Vue from 'vue';

import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(
import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';
import euiPanelyta from 'v-components/euiPanelyta';

import { ssoTooltips } from 'ssoTooltips';

import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiMermeny from 'v-components/euiMermeny';

import euiFlikgruppClasses from 'v-components/classes/euiFlikgruppClasses';
import euiFlikgrupp from 'v-components/euiFlikgrupp';


import euiDialogClasses from 'v-components/classes/euiDialogClasses';
import euiDialog from 'v-components/euiDialog';
//import euiMeddelandedialog from 'v-components/euiMeddelandedialog';
import euiFormTextruta from 'v-components/euiFormTextruta.vue';

import objectToFormData from 'object-to-formdata';

import VeeValidateSsoDashboardNamnUnikt from 'VeeValidateSsoDashboardNamnUnikt';
import VeeValidateRemote from 'VeeValidateRemote';
VeeValidateSsoDashboardNamnUnikt.runOnce();	// Kör funktionen om den inte redan körts!
VeeValidateRemote.runOnce();	// Kör funktionen om den inte redan körts!



window.ssoOversikt = window.ssoOversikt || {};	// För att undvika ESLint-varningar att den är odefinierad.

// Fixa till alla (ev) menyConfig objekt i window.ssoOversikt.widgets, så de är av rätt class type:
for (let i = 0; i < window.ssoOversikt.widgets.length; i++)
{
	if (window.ssoOversikt.widgets[i].menyConfig)
	{
		window.ssoOversikt.widgets[i].menyConfig =
			euiPopUpMenyClasses.menyConfig.castFrom(window.ssoOversikt.widgets[i].menyConfig, { castAlsoNestedObjectsAndArrayValues: true });		// "casta" till rätt typ, inkl alla nästade underobjekt/arrayvärden.
	}
}

//##############################################################################################################################

//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	store,	// ssoStatestore

	// Lokalt registrerade komponenter
	components: {
		euiPanelyta,
		euiMermeny,
		euiDialog,
		//euiMeddelandedialog,
		euiFormTextruta,
		euiFlikgrupp,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
		dashboardPages: window.ssoOversikt.dashboardPages,
		selectedDashboardPage: window.ssoOversikt.selectedDashboardPage,
		selectedDashboardPageIsMainPage: window.ssoOversikt.selectedDashboardPageIsMainPage,

		flikgruppDashboardPagesConfig: undefined,		// Sätts i lifecycle hook created, nedan
		//forceRerenderKey: 0,
		valdFlikIndex: undefined,

		navigeringTillAnnanDashboardpagePagar: false,

		widgets: window.ssoOversikt.widgets,		// Obs! Denna är tillfixad FÖRE Vue-appen initieras (räcker inte i beforeCreate!)
		//widgets: undefined,	// Sätts i lifecycle hook created, nedan

		nyDashboardPageDialogConfig: new euiDialogClasses.dialogConfig([
			new euiDialogClasses.knappAvbryt(),
			//new euiDialogClasses.knappEvent('Test: Event-knapp', 'testEventknapp', { cssModifierClass: '' }),
			new euiDialogClasses.knappEvent('Skapa sidan', 'skapaNyDashboardPage', { validateBeforeEmit: true }),
		]),

		nyDashboardPageFormModel: {
			// Obs! Måste stämma med form model som används i controllern:
			PageName: '',
			//PageId:		// Denna finns i C# form model, men anv inte vid Ny.
		},

		andraDashboardPageDialogConfig: new euiDialogClasses.dialogConfig(
			[
			new euiDialogClasses.knappAvbryt(),
			//new euiDialogClasses.knappEvent('Test: Event-knapp', 'testEventknapp', { cssModifierClass: '' }),
			new euiDialogClasses.knappEvent('Spara', 'sparaAndradDashboardPage', { validateBeforeEmit: true }),
		]),

		andraDashboardPageFormModel: {
			// Obs! Måste stämma med form model som används i controllern:
			PageId: '',
			PageName: '',
		},
	},

	computed: {
		//dashboardPagesCount() {
		//	return this.dashboardPages.length;
		//},

		antalFlikarExklNyGhost()
		{
			if (!this.flikgruppDashboardPagesConfig || !this.flikgruppDashboardPagesConfig.flikar)
				return 0;

			return this.flikgruppDashboardPagesConfig.flikar.length - 1;
		},
	},

	watch:
	{
		// "arIRedigeralage", som denna refererar, är en computed i ssoAllaSidorMixin:
		arIRedigeralage: {
			handler(nyttVarde, tidigareVarde) {
				// Todo: Hade kanske varit snyggare med proparna vpVisaMenyer + vpVisaGhostflikar på flikkomponenten, istället för att generera om hela config?:
				this.flikgruppDashboardPagesConfig = this.byggFlikar();
			},
			immediate: true,			// OBS! Exekveras även initialt!
			//deep: true,
		},

		//dashboardPages: {
		//	handler(nyttVarde, tidigareVarde) {
		//		if (nyttVarde)
		//			this.flikgruppDashboardPagesConfig = this.byggFlikar();
		//	},
		//	//immediate: true,
		//	deep: true,
		//}
	},

	methods: {

		//#####  Eventhanterare:   #################################################

		onFlikKlickad({ eventId, eventData }) {
			switch (eventId) {
				case 'bytDashboardPage':
					{
						this.navigeringTillAnnanDashboardpagePagar = true;
						// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
						this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

						const sida = eventData;		// Enkom för tydlighet.

						// Gå till den valda sidan:
						window.location.href = (sida.PageIsMainPage ? '/' : '/oversikt/' + sida.PageId);
						break;
					}
				case 'nyDashboardPage':
					{
						this.onNyDashboardPage();
						break;
					}
			}
		},

		onMenyalternativValtIFlik({ eventId, eventData }) {
			switch (eventId) {
				case 'andraSida':
					{
						// eventData:
						// pageId: sida.PageId,
						// pageName: sida.Name

						//console.log('Ändra sida', eventData);

						this.onAndraDashboardPage(eventData);
						break;
					}

				case 'taBortSida':
					{
						// eventData:
						// pageId: sida.PageId,
						// pageName: sida.Name

						//console.log('Ta bort sida', eventData);

						this.visaMeddelande(
							`Är du säker på att du vill ta bort sidan <b>${eventData.pageName}</b>?`,
							{
								//dialogId: 'taBortSida',
								ikon: 'fragemeddelande',
								ikonCssModifierClass: '-info',
								knappar: [
										new euiDialogClasses.knappAvbryt(),
										new euiDialogClasses.knappEvent('Ta bort sidan', 'taBortSidaBekraftad', { eventData: eventData }),
									],
								//breddMedEnhet: '36rem',	// Default = '36rem'.
							}
						);

						break;
					}
			}
		},

		onKnappTrycktIMeddelandedialog({ eventId, eventData })
		{
			switch (eventId) {
				case 'taBortSidaBekraftad':
					{
						// eventData:
						// pageId: sida.PageId,
						// pageName: sida.Name

						//console.log('Ta bort sida, EFTER bekräftelsen', eventData);

						this.AjaxpostaOchHanteraResultat('/dashboard-page/delete-dashboard-page', {
							formData: objectToFormData({ pageId: eventData.pageId }),
							//doljSpinnerOnSuccess: false,
							onSuccessFunction: (resultat) => {
								// Gå till huvudsidan:
								// Todo: Laddar om hela sidan så att de nya datana slår igenom. Detta är egentligen ett korkat och omodernt och klumpigt sätt att göra det på, men:
								window.location.href = '/';
							},
						});

						break;
					}
			}
		},

		onNyDashboardPage() {
			// Nedanstående behövs för att vue-komponenten äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
			ssoTooltips.doljAlla();

			this.nyDashboardPageFormModel.PageName = '';
			this.nyDashboardPageDialogConfig.visas = true;
		},

		onKnappTrycktINyDashboardPageDialog({ eventId, eventData }) {
			switch (eventId) {
				case 'skapaNyDashboardPage':
					{
						this.AjaxpostaOchHanteraResultat('/dashboard-page/add-dashboard-page', {
							formData: objectToFormData(this.nyDashboardPageFormModel),
							//doljSpinnerOnSuccess: false,
							onSuccessFunction: (resultat) => {

								// Lite finlir:
								// Byt ut ny-fliken:
								this.flikgruppDashboardPagesConfig.flikar[this.antalFlikarExklNyGhost - 1 + 1] = new euiFlikgruppClasses.flik({
									text: resultat.CustomData.PageName,
									//ikon: 'ny',
									//eventId: 'nyDashboardPage',
									menyConfig: new euiPopUpMenyClasses.menyConfig([]),
									vald: true,
									//arGhost: true,
								});
								// Sätt den som vald (redan gjort ovan, men denna byter på rätt sätt):
								this.valdFlikIndex = this.antalFlikarExklNyGhost - 1 + 1;

								// Först nu ska dialogen stängas!
								this.nyDashboardPageDialogConfig.visas = false;

								// Gå till den nya sidan:

								// Den tidigare spinnern, vid POST, är inte stoppad än:
								//// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
								//this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

								window.location.href = '/oversikt/' + resultat.CustomData.PageId;
							},
						});

						break;
					}
			}
		},

		onAndraDashboardPage(eventData) {

			// eventData:
			// pageId: sida.PageId,
			// pageName: sida.Name

			// Nedanstående behövs för att vue-komponenten äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
			ssoTooltips.doljAlla();

			this.andraDashboardPageFormModel.PageId = eventData.pageId;
			this.andraDashboardPageFormModel.PageName = eventData.pageName;

			this.andraDashboardPageDialogConfig.visas = true;
		},

		onKnappTrycktIAndraDashboardPageDialog({ eventId, eventData }) {
			switch (eventId) {
				case 'sparaAndradDashboardPage':
					{
						this.AjaxpostaOchHanteraResultat('/dashboard-page/update-dashboard-page', {
							formData: objectToFormData(this.andraDashboardPageFormModel),
							//doljSpinnerOnSuccess: false,
							onSuccessFunction: (resultat) => {

								// Lite finlir:
								// Uppdatera namnet i fliken:
								const flikIndex = this.flikgruppDashboardPagesConfig.flikar
									.findIndex(x => x.eventData.PageId === this.andraDashboardPageFormModel.PageId);
								this.flikgruppDashboardPagesConfig.flikar[flikIndex].text = this.andraDashboardPageFormModel.PageName;


								// Först nu ska dialogen stängas!
								this.andraDashboardPageDialogConfig.visas = false;

								// Ladda in sidan på nytt:

								// Den tidigare spinnern, vid POST, är inte stoppad än:
								//// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
								//this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

								window.location.reload(true);
							},
						});

						break;
					}
			}
		},

		// Todo: TEMP onResetPages, endast för intern användning:
		onResetPages() {
			// Nedanstående behövs för att vue-komponenten äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
			ssoTooltips.doljAlla();

			this.AjaxpostaOchHanteraResultat('/dashboard-page/reset-dashboard-pages', {
				//formData: new FormData(),
				//doljSpinnerOnSuccess: false,
				onSuccessFunction: (resultat) => {
					// Ladda in sidan på nytt:
					window.location.reload(true);
				},
			});
		},

		onDialogEllerMeddelandedialogStangs(dialogId)
		{
			switch (dialogId)
			{
				case 'nyDashboardPage':
					{
						// "Nollar" av sanitära skäl alltid form model efteråt (abruten *eller* ok:ad dialog):
						// Görs här trots att ny sidladdning initieras, vilket är lite onödigt:
						this.nyDashboardPageFormModel.PageName = undefined;

						break;
					}

				case 'andraDashboardPage':
					{
						// "Nollar" av sanitära skäl alltid form model efteråt (abruten *eller* ok:ad dialog):
						// Görs här trots att ny sidladdning initieras, vilket är lite onödigt:
						this.andraDashboardPageFormModel.PageId = undefined;
						this.andraDashboardPageFormModel.PageName = undefined;
						break;
					}
			}
		},

		byggFlikar()
		{
			let flikar = [];

			if (this.dashboardPages)
			{
				for (const sida of this.dashboardPages) {

					let mc = undefined;

					if (this.arIRedigeralage
						&& !sida.PageIsMainPage)
					{
						// Om man är i redigeraläge
						// OCH det inte är huvudsidan:
						// Fliken ska ha en mermeny:

						mc = new euiPopUpMenyClasses.menyConfig([
							new euiPopUpMenyClasses.delEvent('Ändra namn', 'andraSida', {
								ikon: 'andra',
								eventData: { pageId: sida.PageId, pageName: sida.Name },
							}),
							new euiPopUpMenyClasses.delEvent('Ta bort', 'taBortSida', {
								ikon: 'taBort',
								cssModifierClass: '-fara',
								eventData: { pageId: sida.PageId, pageName: sida.Name },
							}),
						]);
					}

					let flik = new euiFlikgruppClasses.flik({
						text: sida.Name,
						eventId: 'bytDashboardPage',
						eventData: sida,
						vald: sida.PageId === this.selectedDashboardPage,
						menyConfig: mc,
					});

					flikar.push(flik);
				}
			}

			let flik = new euiFlikgruppClasses.flik({
				text: 'Ny',
				ikon: 'ny',
				eventId: 'nyDashboardPage',
				arGhost: true,
				hidden: !this.arIRedigeralage,
			});
			flikar.push(flik);
			//flikar.push(this.flikNy);

			return new euiFlikgruppClasses.flikgruppConfig(flikar);
		},
	},


	//== Lifecycle hooks  ================================================================================================================

	beforeCreate() {
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Dessa används för att styra funktionalitet i mixin "ssoAllaSidorMixin":
		// Defaultvärde sätts numera i mixinen: this.$_rullningsbaraElementQuerySelectorAll = '.-rullningsbar-auto, .-rullningsbar-overlay, .-rullningsbar-auto-persist, .-rullningsbar-overlay-persist';
		this.$_vuexNamespace = 'oversikt';
	},

	//created()
	//{
	//	// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.
	//},

	//beforeMount()
	//{
	//	// Called right before the mounting begins: the render function is about to be called for the first time.
	//	// This hook is not called during server-side rendering.
	//	// Detta är hooken efter att Vues kompilering är klar. v-cloak är fortfarande kvar, men plockas bort strax efter denna körts.
	//	// Här är det inte lämpligt att förändra DOM, för den ersätts vid den stundande renderingen och då tappas ändringarna (är jag ganska säker på).
	//},

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.
		//console.log('ssoOversiktApp mounted()');

		// Programmatisk bind:
		this.$on('knapp-tryckt-i-meddelandedialog', this.onKnappTrycktIMeddelandedialog);
		this.$on('meddelandedialog-stangs', this.onDialogEllerMeddelandedialogStangs);
		this.$on('dialogen-stangs', this.onDialogEllerMeddelandedialogStangs);

		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			//console.log('ssoOversiktApp mounted.$nextTick()');
		});
	},
});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;

